export enum SaleMemberStatus {
  Pending = 1,
  Review = 2,
  Requested = 5,
  Denied = 4,
  Approved = 3,
}
